<template>
  <section class="test">
    <div class="test--box">
      <div v-if="count != 3" class="test--text">
        <h2>Take Personality Test</h2>
        <p>
          It should not take few minutes to conclude, with immediate result you
          will discover what tech career fits you.
        </p>
      </div>
      <div class="test--tests">
        <div v-if="count === 1">
          <First :count="count" @changeCount="updateCount($event)" />
        </div>
        <div v-if="count === 2">
          <Last :count="count" @updateCount="countUpdate($event)"/>
        </div>
        <div v-if="count === 3">
          <Result />
        </div>
      </div>
    </div>
    <hr v-if="count === 17"/>
    <section v-if="count === 17" class="test--career">
      <div class="test--career--box">
        <div class="test--career--text">
          <h1>Career Profiles</h1>
        </div>
        <div class="test--career--profiles">
          <div class="test--career--profile">
            <svg
              width="100"
              height="100"
              viewBox="0 0 100 100"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M0 32C0 8 8 0 32 0H68C92 0 100 8 100 32V68C100 92 92 100 68 100H32C8 100 0 92 0 68V32Z"
                fill="#8F3D55"
              />
              <path
                d="M50 42C59.9411 42 68 39.3137 68 36C68 32.6863 59.9411 30 50 30C40.0589 30 32 32.6863 32 36C32 39.3137 40.0589 42 50 42Z"
                stroke="white"
                stroke-width="4"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M68 50C68 53.32 60 56 50 56C40 56 32 53.32 32 50"
                stroke="white"
                stroke-width="4"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M32 36V64C32 67.32 40 70 50 70C60 70 68 67.32 68 64V36"
                stroke="white"
                stroke-width="4"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            <h4>Data Science</h4>
            <p>
              Data science combines multiple fields, including statistics,
              scientific methods, artificial intelligence (AI), and data
              analysis, to extract value from data.
            </p>
          </div>

          <div class="test--career--profile">
            <svg
              width="100"
              height="100"
              viewBox="0 0 100 100"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M0 32C0 8 8 0 32 0H68C92 0 100 8 100 32V68C100 92 92 100 68 100H32C8 100 0 92 0 68V32Z"
                fill="#8F3D55"
              />
              <path
                d="M47.6004 35.5992C45.7692 35.5992 44.0604 36.1104 42.6036 37.0008C42.4531 36.1954 42.1786 35.4182 41.79 34.6968C43.6171 33.6857 45.6765 33.1689 47.7645 33.1974C49.8525 33.226 51.897 33.7989 53.6958 34.8596C55.4945 35.9203 56.9854 37.432 58.0209 39.2454C59.0565 41.0588 59.6009 43.111 59.6004 45.1992H65.6028C66.5572 45.1998 67.4723 45.5794 68.1469 46.2545C68.8215 46.9295 69.2004 47.8448 69.2004 48.7992V63.1992C69.2004 64.154 68.8212 65.0697 68.146 65.7448C67.4709 66.4199 66.5552 66.7992 65.6004 66.7992H51.2004C50.2457 66.7992 49.33 66.4199 48.6549 65.7448C47.9797 65.0697 47.6004 64.154 47.6004 63.1992V57.1992C45.931 57.2013 44.2795 56.8539 42.7524 56.1792C42.7836 55.3632 42.8004 54.5064 42.8004 53.5992V53.5152C44.2116 54.3312 45.8508 54.7992 47.6004 54.7992V48.7992C47.6004 47.8444 47.9797 46.9287 48.6549 46.2536C49.33 45.5785 50.2457 45.1992 51.2004 45.1992H57.2004C57.2004 42.6531 56.189 40.2113 54.3887 38.411C52.5883 36.6106 50.1465 35.5992 47.6004 35.5992ZM59.3604 47.5992C58.8884 49.9046 57.7497 52.0205 56.0857 53.6845C54.4218 55.3485 52.3058 56.4871 50.0004 56.9592V63.1992C50.0004 63.5175 50.1269 63.8227 50.3519 64.0477C50.577 64.2728 50.8822 64.3992 51.2004 64.3992H65.6004C65.9187 64.3992 66.2239 64.2728 66.449 64.0477C66.674 63.8227 66.8004 63.5175 66.8004 63.1992V48.7992C66.8004 48.4809 66.674 48.1757 66.449 47.9507C66.2239 47.7256 65.9187 47.5992 65.6004 47.5992H59.3604ZM56.898 47.5992H51.2004C50.8822 47.5992 50.577 47.7256 50.3519 47.9507C50.1269 48.1757 50.0004 48.4809 50.0004 48.7992V54.4968C51.6608 54.0666 53.1759 53.2003 54.3887 51.9875C55.6015 50.7746 56.4679 49.2596 56.898 47.5992Z"
                fill="white"
              />
              <path
                d="M36.9916 31.0997C37.1912 31.2737 37.3276 31.5087 37.3797 31.7683C37.4318 32.0279 37.3966 32.2974 37.2796 32.5349C37.2592 32.6051 37.2487 32.6778 37.2484 32.7509C37.2484 32.9021 37.2868 33.1901 37.6492 33.5501C37.8244 33.7253 37.9588 33.8501 38.1052 33.9869C38.2252 34.0973 38.3524 34.2125 38.5132 34.3709C38.8252 34.6685 39.154 35.0189 39.4492 35.4581C40.0612 36.3773 40.3996 37.5269 40.3996 39.1997C40.3996 41.2469 39.6412 42.9917 38.458 44.0621L38.6116 44.2397C39.2836 45.0653 39.6748 46.1357 39.9196 47.1917C40.3996 49.2797 40.3996 51.7901 40.3996 53.5397V53.5997C40.3996 60.2885 39.49 64.0829 38.4892 66.2525C37.9852 67.3445 37.45 68.0405 36.9868 68.4773C36.7984 68.658 36.5908 68.8173 36.3676 68.9525C36.2653 69.014 36.1586 69.0678 36.0484 69.1133C36.0484 69.1133 35.7772 69.1997 35.5996 69.1997C35.422 69.1997 35.1508 69.1133 35.1508 69.1133C35.0393 69.0705 34.9323 69.0166 34.8316 68.9525C34.6083 68.8173 34.4007 68.658 34.2124 68.4773C33.7492 68.0381 33.214 67.3445 32.71 66.2525C31.7092 64.0829 30.7996 60.2885 30.7996 53.5997V53.5397C30.7996 51.7877 30.7996 49.2797 31.2796 47.1917C31.5244 46.1357 31.9156 45.0653 32.5876 44.2397C32.6356 44.1797 32.6884 44.1197 32.7412 44.0621C31.558 42.9917 30.7996 41.2469 30.7996 39.1997C30.7996 38.4173 31.0084 37.4837 31.2964 36.6221C31.5844 35.7581 31.9876 34.8653 32.4532 34.1453C33.0076 33.2093 33.7876 32.4245 34.3924 31.8965C34.7239 31.6049 35.07 31.3302 35.4292 31.0733L35.5012 31.0253L35.5228 31.0085L35.53 31.0037L35.5348 31.0013C35.7548 30.8546 36.0172 30.7847 36.2811 30.8025C36.545 30.8203 36.7956 30.9248 36.994 31.0997H36.9916ZM35.6068 42.7997C36.526 42.7973 37.9996 41.7677 37.9996 39.1997C37.9996 37.8725 37.738 37.2221 37.45 36.7901C37.2749 36.5378 37.0729 36.3052 36.8476 36.0965L36.55 35.8181C36.3556 35.6357 36.1276 35.4245 35.95 35.2493C35.6875 34.9896 35.4621 34.6948 35.2804 34.3733C34.9749 34.6945 34.706 35.0487 34.4788 35.4293C34.1428 35.9453 33.8164 36.6533 33.574 37.3829C33.3244 38.1269 33.1996 38.7845 33.1996 39.1997C33.1996 41.7725 34.6756 42.7997 35.5996 42.7997H35.6044H35.6068ZM34.4476 45.7565C34.1092 46.1717 33.8236 46.8341 33.6196 47.7317C33.2044 49.5269 33.1996 51.7829 33.1996 53.5997C33.1996 60.1109 34.09 63.5165 34.8892 65.2469C35.1532 65.8157 35.4004 66.1949 35.5996 66.4469C35.7988 66.1949 36.0484 65.8157 36.31 65.2469C37.1092 63.5165 37.9996 60.1109 37.9996 53.5997C37.9996 51.7829 37.9948 49.5269 37.5796 47.7317C37.3732 46.8341 37.09 46.1717 36.7516 45.7565C36.6192 45.5771 36.4451 45.4327 36.2444 45.3357C36.0437 45.2387 35.8224 45.192 35.5996 45.1997H35.5948C35.3727 45.1926 35.1523 45.2395 34.9525 45.3365C34.7526 45.4335 34.5793 45.5777 34.4476 45.7565Z"
                fill="white"
              />
            </svg>

            <h4>Product Design</h4>
            <p>
              Product design describes the process of imagining, creating, and
              iterating products that solve users’ problems or address specific
              needs in a given market.
            </p>
          </div>

          <div class="test--career--profile">
            <svg
              width="100"
              height="100"
              viewBox="0 0 100 100"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M0 32C0 8 8 0 32 0H68C92 0 100 8 100 32V68C100 92 92 100 68 100H32C8 100 0 92 0 68V32Z"
                fill="#8F3D55"
              />
              <path
                d="M57.4333 30.9413C57.4912 30.753 57.5114 30.5551 57.4929 30.3589C57.4743 30.1628 57.4173 29.9722 57.3251 29.7981C57.2329 29.624 57.1073 29.4698 56.9555 29.3442C56.8036 29.2186 56.6286 29.1242 56.4403 29.0663C56.2519 29.0084 56.0541 28.9881 55.8579 29.0067C55.6618 29.0252 55.4712 29.0822 55.2971 29.1745C55.123 29.2667 54.9688 29.3923 54.8432 29.5441C54.7176 29.6959 54.6232 29.871 54.5653 30.0593L42.5653 69.0593C42.4483 69.4396 42.4872 69.8508 42.6734 70.2024C42.8597 70.5541 43.1779 70.8173 43.5583 70.9343C43.9386 71.0512 44.3498 71.0123 44.7014 70.8261C45.053 70.6399 45.3163 70.3216 45.4333 69.9413L57.4333 30.9413ZM40.5613 38.4383C40.701 38.5776 40.8118 38.7431 40.8874 38.9254C40.963 39.1076 41.0019 39.303 41.0019 39.5003C41.0019 39.6976 40.963 39.8929 40.8874 40.0752C40.8118 40.2574 40.701 40.4229 40.5613 40.5623L31.1203 50.0003L40.5613 59.4383C40.8429 59.7199 41.0012 60.102 41.0012 60.5003C41.0012 60.8986 40.8429 61.2806 40.5613 61.5623C40.2796 61.8439 39.8976 62.0022 39.4993 62.0022C39.1009 62.0022 38.7189 61.8439 38.4373 61.5623L27.9373 51.0623C27.7976 50.9229 27.6867 50.7574 27.6111 50.5752C27.5355 50.3929 27.4966 50.1976 27.4966 50.0003C27.4966 49.803 27.5355 49.6076 27.6111 49.4254C27.6867 49.2431 27.7976 49.0776 27.9373 48.9383L38.4373 38.4383C38.5766 38.2986 38.7421 38.1878 38.9244 38.1121C39.1066 38.0365 39.302 37.9976 39.4993 37.9976C39.6966 37.9976 39.8919 38.0365 40.0742 38.1121C40.2564 38.1878 40.4219 38.2986 40.5613 38.4383ZM59.4373 38.4383C59.2976 38.5776 59.1867 38.7431 59.1111 38.9254C59.0355 39.1076 58.9966 39.303 58.9966 39.5003C58.9966 39.6976 59.0355 39.8929 59.1111 40.0752C59.1867 40.2574 59.2976 40.4229 59.4373 40.5623L68.8783 50.0003L59.4373 59.4383C59.2978 59.5777 59.1872 59.7433 59.1117 59.9255C59.0362 60.1077 58.9974 60.303 58.9974 60.5003C58.9974 60.6975 59.0362 60.8928 59.1117 61.075C59.1872 61.2572 59.2978 61.4228 59.4373 61.5623C59.5767 61.7017 59.7423 61.8124 59.9245 61.8879C60.1067 61.9633 60.302 62.0022 60.4993 62.0022C60.6965 62.0022 60.8918 61.9633 61.074 61.8879C61.2562 61.8124 61.4218 61.7017 61.5613 61.5623L72.0613 51.0623C72.201 50.9229 72.3118 50.7574 72.3874 50.5752C72.463 50.3929 72.5019 50.1976 72.5019 50.0003C72.5019 49.803 72.463 49.6076 72.3874 49.4254C72.3118 49.2431 72.201 49.0776 72.0613 48.9383L61.5613 38.4383C61.4219 38.2986 61.2564 38.1878 61.0742 38.1121C60.8919 38.0365 60.6966 37.9976 60.4993 37.9976C60.302 37.9976 60.1066 38.0365 59.9244 38.1121C59.7421 38.1878 59.5766 38.2986 59.4373 38.4383Z"
                fill="white"
              />
            </svg>

            <h4>Web Development</h4>
            <p>
              Web development can range from developing a simple single static
              page of plain text to complex web applications, electronic
              businesses, and social network services.
            </p>
          </div>
        </div>
      </div>
    </section>
  </section>
</template>

<script>
import First from "@/components/Personality/PersonalityTest/First/Test.vue";
import Last from "@/components/Personality/PersonalityTest/Last/Test.vue";
import Result from "@/components/Personality/PersonalityTest/Results/Results.vue";
export default {
  components: {
    First,
    Last,
    Result,
  },
  data() {
    return {
      count: 1,
    };
  },
  mounted() {
    window.scrollTo(0,0)
  },
  methods: {
    updateCount(countUpdate) {
      this.count = countUpdate;
    },
    countUpdate(countUpdated) {
      this.count = countUpdated;
    }
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/_mixins.scss";
@import "@/styles/_variables.scss";
@import "@/styles/_typography.scss";

.test {
  background: #f7efea;
}
.test--box {
  padding: 5rem 7%;
  text-align: center;
}
.test--text {
  h2 {
    margin-bottom: 1rem;
    @include heading2 {
      color: $secondary-80;
      font-family: $karla;
    }
  }
  p {
    padding: 0 20rem;
    @include caption {
      color: $black-50;
      font-family: $karla;
    }
  }
}
hr {
  border: 3px solid #daadbb;
}
.test--career--box {
  padding: 5rem 7%;
  text-align: center;
}
.test--career--text {
  margin-bottom: 4rem;
  h1 {
    @include heading2 {
      color: $secondary;
      font-family: $karla;
    }
  }
}
.test--career--profiles {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  grid-gap: 4rem;
  margin-top: 3rem;

  .test--career--profile {
    width: min(85%, 23rem);
    height: 278px;
    padding-top: 5rem;
    background: $white;
    border-radius: 6px;
    position: relative;
    margin: 0.6rem 0;
    svg {
      position: absolute;
      bottom: 14rem;
      left: 33%;
    }
    h4 {
      @include sub-heading-bold {
        color: $black-100;
        font-family: $karla;
      }
    }
    p {
      padding: 0.8rem 1.5rem;
      @include caption {
        color: $black-100;
        font-family: $karla;
      }
    }
  }
}
@include xl {
  .test--text {
    
  h2 {
    margin-bottom: 1rem;
    @include heading2 {
      color: $secondary-80;
      font-family: $karla;
    }
  }
  p {
    padding: 0 0rem;
    max-width: 100vw;
    width: min(75%, 400px);
    margin: 0 auto;
    @include caption {
      color: $black-50;
      font-family: $karla;
    }
  }
}
}
@include lg {
  .test--text {
    
  h2 {
    margin-bottom: 1rem;
    @include heading2 {
      font-size: 1.7rem;
    }
  }
  p {
    @include caption {
      font-size: 0.9rem;
    }
  }
}
.test--career--profiles {
.test--career--profile {
    width: min(85%, 23rem);
    height: auto;
    padding-top: 3rem;
    svg {
      bottom: 80%;
    }
    h4 {
      @include sub-heading-bold {
        font-size: 1.3rem;
      }
    }
    p {
      padding: 0.8rem 1rem;
      @include caption {
      }
    }
  }
}
}
@include xs {
  .test--text {
    
  h2 {
    margin-bottom: 1rem;
    @include heading2 {
      font-size: 1.2rem;
    }
  }
  p {
    @include caption {
      font-size: 0.9rem;
    }
  }
}
}
</style>